module.exports = __webpack_public_path__ + "static/media/american-express.a3a61038.svg";